import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"
import DataTable from "react-data-table-component"
import { Link } from "react-router-dom"
import ApplicationService from "../../services/applications/Application.service"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

let appService = null

function MessageHistory() {
  const [messages, setmessages] = useState([])
  const [paginationInfo, setpaginationInfo] = useState({
    per_page: 10,
    total: 0,
  })
  const [rowData, setrowData] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedMessage, setSelectedMessage] = useState("")
  const columns = [
    {
      name: "SUBJECT",
      selector: "subject",
      sortable: true,
    },
    {
      name: "MESSAGE",
      cell: row => (
        <button
          className="btn btn-link"
          onClick={() => toggleModal(row.message)}
        >
          View Message
        </button>
      ),
    },
    {
      name: "TARGET GROUP",
      selector: "targetGroup",
      sortable: true,
    },
    {
      name: "COMMUNICATION TYPE",
      selector: "communicationType",
      sortable: true,
    },
    {
      name: "DATE SENT",
      selector: "dateSent",
      sortable: true,
    },
    {
      name: "RECIPIENTS",
      cell: row =>
        row.targetGroup == "SELECTED CLIENTS" ||
        row.targetGroup == "SELECTED COMPANIES" ? (
          <Link to={`/message-history-item?id=${row.id}`}>View</Link>
        ) : (
          row.targetGroup
        ),
      button: true,
    },
  ]

  const toggleModal = message => {
    setSelectedMessage(message)
    setModalOpen(!modalOpen)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)
    fetchMessages(0)
  }, [])

  const fetchMessages = async page => {
    const response = await appService.getMessageHistory(page)

    if (response.status) {
      setpaginationInfo({
        per_page: response.data.per_page,
        total: response.data.total,
      })

      const rws = response.data.data.map((item, index) => {
        return {
          id: item.id,
          targetGroup: item.recipient_group,
          subject: item.subject,
          communicationType: item.communication_type,
          dateSent: new Date(item.created_at).toLocaleString(),
          message: item.message,
        }
      })

      setrowData(rws)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Message History</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Message History</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All message history will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          <div>
            <DataTable
              title="Messages"
              columns={columns}
              data={rowData}
              pagination
              highlightOnHover
              paginationServer
              paginationTotalRows={paginationInfo.total}
              paginationPerPage={paginationInfo.per_page}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              onChangePage={page => fetchMessages(page)}
            />

            {/* Message Modal */}
            <Modal isOpen={modalOpen} toggle={() => toggleModal("")}>
              <ModalHeader>Message Body</ModalHeader>
              <ModalBody>
                <textarea readOnly className="form-control" rows={10}>
                  {selectedMessage}
                </textarea>
              </ModalBody>
              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  onClick={() => toggleModal("")}
                >
                  Close
                </button>
              </ModalFooter>
            </Modal>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default MessageHistory
